var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 546.713,
    height: 379.778,
    viewBox: "0 0 546.713 379.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(-114.659 -66.21)",
    opacity: 0.572
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_613",
    "data-name": "Caminho 613",
    d: "M142.951,311.9a19.518,19.518,0,1,0,9.724,25.834A19.515,19.515,0,0,0,142.951,311.9Z",
    transform: "translate(0 9.759)",
    fill: "none",
    stroke: "#220d59",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_476",
    "data-name": "Grupo 476",
    transform: "translate(188.129 90.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_419",
    "data-name": "Grupo 419",
    transform: "translate(49.148 30.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_614",
    "data-name": "Caminho 614",
    d: "M290.758,127.178c-.874-4.836-6.874-7.561-11.19-7.956s-9.953,1.321-12.8,4.15c-1.955,1.945-3.307,4.534-6.032,5.574-2.4.915-5.366.4-7.613,1.56-5.408,2.787-1.217,11.336-6.074,14.8-1.758,1.258-4.41,1.55-5.668,3.182-1.726,2.246.343,5.283-.25,7.935-.926,4.181-7.894,5.866-8.5,10.088-.562,3.879,4.5,6.417,6.573,9.89.957,1.6,1.29,3.463,2.506,4.93,1.622,1.955,4.462,2.818,7.166,3.4a22.6,22.6,0,0,0,7.134.655c8.3-.842,13.822-8.913,22.142-9.516,3.64-.26,7.3.988,10.91.468,4.9-.718,8.663-5.106,8.018-9.36-.343-2.278-1.768-4.441-1.55-6.729.312-3.12,3.578-5.554,3.921-8.663.426-3.89-5.065-7.831-4.67-11.721.239-2.35,1.321-4.41,1.914-6.718,1.154-4.576-2.288-6.781-6.978-6.126",
    transform: "translate(-232.589 -119.166)",
    fill: "#220d59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_420",
    "data-name": "Grupo 420",
    transform: "translate(46.203 69.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_615",
    "data-name": "Caminho 615",
    d: "M284.968,211.972l7.79,34.466s-38.823,2.288-58.417-17.233c0,0-14.279-77.012,31.6-72.759C301.276,159.723,301.192,178.786,284.968,211.972Z",
    transform: "translate(-229.658 -156.277)",
    fill: "#9b5eed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_616",
    "data-name": "Caminho 616",
    d: "M311.16,414.816l-11.554-.686-.666,17.5,5.252-.125-.291-1.976,6.885,2.257,27.831.281a38.456,38.456,0,0,0-14.862-7.415,19.409,19.409,0,0,1-12.594-9.838Z",
    transform: "translate(-226.989 -145.961)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_617",
    "data-name": "Caminho 617",
    d: "M248.841,413.817l-9.474-.707-3.026,17.919,5.377-.135.884-2.018,8.226,2.309,26.146.291a39.23,39.23,0,0,0-15.34-7.613,19.537,19.537,0,0,1-12.74-9.942Z",
    transform: "translate(-229.493 -146.002)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_618",
    "data-name": "Caminho 618",
    d: "M288.957,224.56s-29.942,15.579-54.434,1.716c0,0-9.651,22.62-1.487,54s18.73,86.528,1.654,143.437c0,0,12.927,6.687,24.482,2.673,0,0,25.8-60.747,24.315-100.142,0,0,20.779,35.755,11.877,98.5,0,0,13.354,5.106,25.23.728,0,0,8.9-29.183,9.651-60.559s-6.677-66.394-17.8-89.014S291.692,231.341,288.957,224.56Z",
    transform: "translate(-229.757 -153.545)",
    fill: "#548aef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_422",
    "data-name": "Grupo 422",
    transform: "translate(53.928 146.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_421",
    "data-name": "Grupo 421",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_619",
    "data-name": "Caminho 619",
    d: "M239.364,230.209c-5.938,27.331,1.706,55.058,5.73,82.077,3.349,22.474,4.888,45.4,3.13,68.079a270.621,270.621,0,0,1-7.5,44.939.335.335,0,0,0,.645.177,264.633,264.633,0,0,0,8.07-74.35c-.4-10.712-1.414-21.393-2.746-32.022-1.747-13.957-4.649-27.737-6.687-41.652-2.278-15.59-3.38-31.543-.01-47.06.1-.426-.541-.6-.634-.187Z",
    transform: "translate(-237.184 -229.973)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_620",
    "data-name": "Caminho 620",
    d: "M296.344,388.142s6.49-72.332-24.014-120.422c0,0,8.871,21.278,9.953,57.866,0,0,2.215,5.46,4.545,11.066C294.617,355.382,296.344,388.142,296.344,388.142Z",
    transform: "translate(-181.85 -82.308)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_424",
    "data-name": "Grupo 424",
    transform: "translate(89.707 184.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_423",
    "data-name": "Grupo 423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_621",
    "data-name": "Caminho 621",
    d: "M271.611,267.226a157.99,157.99,0,0,1,6.157,21.206,169.893,169.893,0,0,1,3.817,24.95,93.625,93.625,0,0,1,.125,12.667c-.031.426.645.426.676,0a112.818,112.818,0,0,0-1.29-23.307,190.74,190.74,0,0,0-5.127-24.253c-1.082-3.858-2.288-7.7-3.7-11.451-.156-.4-.811-.218-.655.187Z",
    transform: "translate(-271.587 -266.817)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_426",
    "data-name": "Grupo 426",
    transform: "translate(55.093 147.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_425",
    "data-name": "Grupo 425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_622",
    "data-name": "Caminho 622",
    d: "M254.877,231.446a19.732,19.732,0,0,1-16.245,8.445.338.338,0,0,0,0,.676,20.445,20.445,0,0,0,16.827-8.778c.239-.364-.343-.7-.582-.343Z",
    transform: "translate(-238.305 -231.295)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_428",
    "data-name": "Grupo 428",
    transform: "translate(54.771 148.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_427",
    "data-name": "Grupo 427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_623",
    "data-name": "Caminho 623",
    d: "M259.955,232.286c-4.274,8-12.782,12-21.632,12.064a.338.338,0,0,0,0,.676c9.079-.052,17.826-4.191,22.215-12.4.2-.385-.374-.728-.582-.343Z",
    transform: "translate(-237.995 -232.118)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_430",
    "data-name": "Grupo 430",
    transform: "translate(48.569 149.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_429",
    "data-name": "Grupo 429",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_624",
    "data-name": "Caminho 624",
    d: "M232.176,234.125a6.652,6.652,0,0,0,3.141,1.258c.426.052.426-.614,0-.676a5.9,5.9,0,0,1-2.8-1.165c-.354-.25-.686.333-.343.582Z",
    transform: "translate(-232.032 -233.481)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_432",
    "data-name": "Grupo 432",
    transform: "translate(47.325 153.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_431",
    "data-name": "Grupo 431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_625",
    "data-name": "Caminho 625",
    d: "M234.387,238.119a5.933,5.933,0,0,1-3.058-.967c-.364-.239-.7.343-.343.582a6.585,6.585,0,0,0,3.4,1.061.338.338,0,0,0,0-.676Z",
    transform: "translate(-230.835 -237.096)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_434",
    "data-name": "Grupo 434",
    transform: "translate(89.59 146.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_433",
    "data-name": "Grupo 433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_626",
    "data-name": "Caminho 626",
    d: "M271.647,230.366a71.882,71.882,0,0,1-.166,23.691c-.073.426.572.6.645.177a72.668,72.668,0,0,0,.166-24.055c-.062-.416-.718-.239-.645.187Z",
    transform: "translate(-271.475 -229.943)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_436",
    "data-name": "Grupo 436",
    transform: "translate(100.404 143.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_435",
    "data-name": "Grupo 435",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_627",
    "data-name": "Caminho 627",
    d: "M289.15,230.252a8.063,8.063,0,0,1-6.718-3.068c-.27-.333-.749.146-.478.478a8.668,8.668,0,0,0,7.2,3.266c.426-.021.437-.7,0-.676Z",
    transform: "translate(-281.873 -227.072)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_438",
    "data-name": "Grupo 438",
    transform: "translate(96.174 144.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_437",
    "data-name": "Grupo 437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_628",
    "data-name": "Caminho 628",
    d: "M291.33,234.02a13.859,13.859,0,0,1-12.886-5.824c-.239-.354-.822-.021-.582.343A14.521,14.521,0,0,0,291.33,234.7c.416-.052.426-.728,0-.676Z",
    transform: "translate(-277.806 -228.045)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_629",
    "data-name": "Caminho 629",
    d: "M277.6,159.79l.125-3.474s8.372,2.714,9.2-4.732c1.456-12.969,2.59-16.4-2.3-20.935s-19.136-.27-19.479,10.681l-.9,15.881a11.721,11.721,0,0,0,5.8,2.725A16.616,16.616,0,0,0,277.6,159.79Z",
    transform: "translate(-182.174 -87.863)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_630",
    "data-name": "Caminho 630",
    d: "M277.942,141.8c-.1.51,0,.967.239,1.009s.5-.333.6-.853,0-.967-.239-1.009S278.046,141.283,277.942,141.8Z",
    transform: "translate(-181.628 -87.38)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_631",
    "data-name": "Caminho 631",
    d: "M284.322,142.993c-.1.51,0,.967.239,1.009s.5-.333.6-.853,0-.967-.239-1.009S284.426,142.483,284.322,142.993Z",
    transform: "translate(-181.372 -87.332)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_632",
    "data-name": "Caminho 632",
    d: "M277.747,155.489a14.142,14.142,0,0,1-6.947-4.659l6.542,8.31Z",
    transform: "translate(-181.912 -86.984)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_633",
    "data-name": "Caminho 633",
    d: "M268.3,143.338a4.59,4.59,0,0,1,5.637-3.151,4.5,4.5,0,0,1,3.2,5.543,4.59,4.59,0,0,1-5.637,3.151A4.507,4.507,0,0,1,268.3,143.338Z",
    transform: "translate(-182.018 -87.417)",
    fill: "#ed743a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_439",
    "data-name": "Grupo 439",
    transform: "translate(103.095 56.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_634",
    "data-name": "Caminho 634",
    d: "M284.626,146.628a4.492,4.492,0,0,1,2.34-2.808c-.229,2.018-.52,4.358-.832,7.166a2.306,2.306,0,0,1-.052.26A4.43,4.43,0,0,1,284.626,146.628Z",
    transform: "translate(-284.461 -143.82)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_635",
    "data-name": "Caminho 635",
    d: "M284.626,146.628a4.492,4.492,0,0,1,2.34-2.808c-.229,2.018-.52,4.358-.832,7.166a2.306,2.306,0,0,1-.052.26A4.43,4.43,0,0,1,284.626,146.628Z",
    transform: "translate(-284.461 -143.82)",
    fill: "#ed743a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_636",
    "data-name": "Caminho 636",
    d: "M283.264,139.4l-1.165-.312-1.81,6.458,2.818.759Z",
    transform: "translate(-181.532 -87.454)",
    fill: "#ed743a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_637",
    "data-name": "Caminho 637",
    d: "M278.22,137.8c-.031.354.458.686,1.092.738s1.165-.2,1.2-.551-.458-.686-1.092-.738S278.251,137.448,278.22,137.8Z",
    transform: "translate(-181.615 -87.528)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_638",
    "data-name": "Caminho 638",
    d: "M284.592,138.868c-.2.3.073.811.6,1.154s1.123.374,1.321.073-.073-.811-.6-1.154S284.79,138.566,284.592,138.868Z",
    transform: "translate(-181.362 -87.471)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_639",
    "data-name": "Caminho 639",
    d: "M260.965,141.642a4.038,4.038,0,0,1,4.94-2.766,3.94,3.94,0,0,1,2.808,4.857,4.038,4.038,0,0,1-4.94,2.766A3.952,3.952,0,0,1,260.965,141.642Z",
    transform: "translate(-182.311 -87.468)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_441",
    "data-name": "Grupo 441",
    transform: "translate(81.848 53.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_440",
    "data-name": "Grupo 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_640",
    "data-name": "Caminho 640",
    d: "M264.28,141.07a2.073,2.073,0,0,1,1.778,2.33c-.052.322.447.468.5.135a2.593,2.593,0,0,0-2.278-2.985c-.333-.042-.333.478,0,.52Z",
    transform: "translate(-264.03 -140.548)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_442",
    "data-name": "Grupo 442",
    transform: "translate(82.774 39.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_641",
    "data-name": "Caminho 641",
    d: "M286.043,131.448c-.593,2.08-2.881,3.255-5.054,3.6s-4.42.1-6.573.541-4.358,1.862-4.649,4a3.964,3.964,0,0,1-.354,1.716,1.684,1.684,0,0,1-1.737.614,2.991,2.991,0,0,1-1.591-1.082,5.812,5.812,0,0,1-1.03-4.8,9.859,9.859,0,0,1,2.4-4.43,13.269,13.269,0,0,1,8.528-4.482,10.437,10.437,0,0,1,8.85,3.442",
    transform: "translate(-264.92 -127.077)",
    fill: "#220d59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_444",
    "data-name": "Grupo 444",
    transform: "translate(74.741 70.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_443",
    "data-name": "Grupo 443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_642",
    "data-name": "Caminho 642",
    d: "M282.9,161.472a19.083,19.083,0,0,1-25.147-4.347c-.27-.343-.738.135-.478.478a19.738,19.738,0,0,0,25.958,4.451c.374-.229.042-.811-.333-.582Z",
    transform: "translate(-257.197 -157.006)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_447",
    "data-name": "Grupo 447",
    transform: "translate(90.448 57.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_643",
    "data-name": "Caminho 643",
    d: "M283.674,167.439s17.8,15.59,38.054,13.354,26.354-25.012,27.051-33.343l18.5-2.34a63.263,63.263,0,0,1-9,37.461c-13.218,21.684-43.951,36.213-79.644,13.094Z",
    transform: "translate(-272.046 -145.11)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_644",
    "data-name": "Caminho 644",
    d: "M272.3,191.441c22.547,15.4,38.927,15.07,38.927,15.07a46.061,46.061,0,0,1,4.43-26.385C300.89,175.3,298.123,167,283.366,161.01",
    transform: "translate(-272.3 -144.474)",
    fill: "#9b5eed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_446",
    "data-name": "Grupo 446",
    transform: "translate(30.544 33.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_445",
    "data-name": "Grupo 445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_645",
    "data-name": "Caminho 645",
    d: "M307.546,177.336a40.484,40.484,0,0,0-5.335,27.311c.073.426.718.25.645-.177a39.812,39.812,0,0,1,5.273-26.791.338.338,0,0,0-.582-.343Z",
    transform: "translate(-301.67 -177.174)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_646",
    "data-name": "Caminho 646",
    d: "M349.868,186.14c-2.683-1.03-7.062,1.04-9.8,4.618-2,2.621-2.257,5.741-1.362,7.415a72.946,72.946,0,0,0,8.809-6.75,21.14,21.14,0,0,0,4-4.368A4.633,4.633,0,0,0,349.868,186.14Z",
    transform: "translate(-269.663 -143.479)",
    fill: "#ed743a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_448",
    "data-name": "Grupo 448",
    transform: "translate(96.711 60.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_647",
    "data-name": "Caminho 647",
    d: "M280.431,147.824a1.862,1.862,0,0,1,1.165,1.529c0,.218-.042.666-.447.707s-.738-.364-1.144-.5-1.05.156-1.456-.208a.753.753,0,0,1-.125-.915,1.835,1.835,0,0,1,2.09-.6",
    transform: "translate(-278.322 -147.724)",
    fill: "#220d59"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_648",
    "data-name": "Caminho 648",
    d: "M346.09,147.68s1.154-13.135,13.738-5.938a17.2,17.2,0,0,0,6.521.229c4.4-.707,8.154-4.566,9.672-1.352,1.217,2.59-7.644,7.415-13.042,6.968S346.09,147.68,346.09,147.68Z",
    transform: "translate(-178.9 -87.443)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_449",
    "data-name": "Grupo 449",
    transform: "translate(176.654 49.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_649",
    "data-name": "Caminho 649",
    d: "M355.19,140.264c4.16.718,8.809,1.009,13.614-2.049,2.538-1.612,3.692-.686,4.014-.177.437.686-.073,1.581-.624,2.184A13.15,13.15,0,0,1,362.2,144.5",
    transform: "translate(-355.19 -137.308)",
    fill: "#ffa12e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_450",
    "data-name": "Grupo 450",
    transform: "translate(183.217 55.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_650",
    "data-name": "Caminho 650",
    d: "M361.5,146.513a15.221,15.221,0,0,0,9.714-2.766,5.009,5.009,0,0,1,1.716-.915,1.258,1.258,0,0,1,1.487.863,2.918,2.918,0,0,1-1.1,2.621c-3.089,3.006-8.039,5.169-11.69,4.358",
    transform: "translate(-361.5 -142.806)",
    fill: "#ffa12e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_452",
    "data-name": "Grupo 452",
    transform: "translate(185.411 55.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_451",
    "data-name": "Grupo 451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_651",
    "data-name": "Caminho 651",
    d: "M363.922,146.54a16.725,16.725,0,0,0,4.441-1.456c1.6-.759,3.567-2.2,5.387-1.924.312.052.447-.437.135-.478-1.633-.26-3.12.645-4.545,1.352a19.66,19.66,0,0,1-5.554,2.018c-.312.062-.177.541.135.489Z",
    transform: "translate(-363.61 -142.636)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_454",
    "data-name": "Grupo 454",
    transform: "translate(183.338 51.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_453",
    "data-name": "Grupo 453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_652",
    "data-name": "Caminho 652",
    d: "M361.922,144.137a35.014,35.014,0,0,0,6.885-2.454,36.007,36.007,0,0,1,3.723-1.924c.3-.114.166-.593-.135-.478a29.677,29.677,0,0,0-3.432,1.768,33.02,33.02,0,0,1-7.166,2.61.247.247,0,0,0,.125.478Z",
    transform: "translate(-361.616 -139.263)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_455",
    "data-name": "Grupo 455",
    transform: "translate(168.137 47.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_653",
    "data-name": "Caminho 653",
    d: "M347,144.3c1.841-3.921,6.313-7.2,9.069-8.788a3.456,3.456,0,0,1,1.466-.551,1.317,1.317,0,0,1,1.321.686,1.8,1.8,0,0,1-.146,1.383,9.465,9.465,0,0,1-5.73,5.262",
    transform: "translate(-347 -134.956)",
    fill: "#ffa12e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(172.796 57.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_456",
    "data-name": "Grupo 456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_654",
    "data-name": "Caminho 654",
    d: "M351.948,147.288a3.816,3.816,0,0,1,5.73-.874c.239.218.593-.135.354-.354a4.313,4.313,0,0,0-6.51.978.247.247,0,0,0,.426.25Z",
    transform: "translate(-351.48 -144.992)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_458",
    "data-name": "Grupo 458",
    transform: "translate(175.281 48.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_655",
    "data-name": "Caminho 655",
    d: "M353.87,139.172a14.034,14.034,0,0,0,7.332.26,36.4,36.4,0,0,0,5.325-2.392,3.892,3.892,0,0,1,1.664-.52,1.34,1.34,0,0,1,1.342.926,1.881,1.881,0,0,1-.832,1.643,12.657,12.657,0,0,1-10.712,2.881",
    transform: "translate(-353.87 -136.52)",
    fill: "#ffa12e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_460",
    "data-name": "Grupo 460",
    transform: "translate(182.182 50.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_459",
    "data-name": "Grupo 459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_656",
    "data-name": "Caminho 656",
    d: "M360.822,141.9c3.006-.572,5.72-2.246,8.362-3.713a.252.252,0,0,0-.25-.437c-2.61,1.456-5.273,3.1-8.237,3.661-.333.062-.2.541.125.489Z",
    transform: "translate(-360.505 -137.718)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_463",
    "data-name": "Grupo 463",
    transform: "translate(0 10.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_657",
    "data-name": "Caminho 657",
    d: "M256.4,163.711s-23.379,3.6-39.281-9.152-8.809-35.256-4.93-42.651L197.852,100a63.305,63.305,0,0,0-12.511,36.442c-.489,25.387,17.649,54.143,60.164,53.8Z",
    transform: "translate(-185.331 -100)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_658",
    "data-name": "Caminho 658",
    d: "M251.965,188.523c-27.3.894-40.935-8.185-40.935-8.185A46.093,46.093,0,0,0,221.461,155.7c15.049,3.858,21.84-1.654,37.5,1.206",
    transform: "translate(-184.303 -97.772)",
    fill: "#9b5eed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_462",
    "data-name": "Grupo 462",
    transform: "translate(31.93 59.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_461",
    "data-name": "Grupo 461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_659",
    "data-name": "Caminho 659",
    d: "M226.066,157.512a39.832,39.832,0,0,1-9.942,25.428c-.291.322.187.79.478.478a40.511,40.511,0,0,0,10.14-25.907c.01-.437-.666-.426-.676,0Z",
    transform: "translate(-216.033 -157.189)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_660",
    "data-name": "Caminho 660",
    d: "M187.613,142.377c2.818.572,5.408,4.67,5.782,9.152.281,3.286-1.175,6.063-2.829,6.989A74.124,74.124,0,0,1,186.75,148.1a21.515,21.515,0,0,1-1.03-5.834A4.54,4.54,0,0,1,187.613,142.377Z",
    transform: "translate(-185.315 -98.312)",
    fill: "#ed743a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_661",
    "data-name": "Caminho 661",
    d: "M212.02,112.3s6.084-11.7-8.4-12.386a17.3,17.3,0,0,1-5.626-3.307c-3.338-2.964-4.43-8.226-7.436-6.323-2.413,1.529,2.465,10.369,7.259,12.886S212.02,112.3,212.02,112.3Z",
    transform: "translate(-185.147 -89.422)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_464",
    "data-name": "Grupo 464",
    transform: "translate(8.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_662",
    "data-name": "Caminho 662",
    d: "M207.914,100.911c-3.9-1.633-7.977-3.879-10.39-9.038-1.269-2.725-2.746-2.558-3.3-2.3-.738.354-.79,1.373-.655,2.184a13.176,13.176,0,0,0,6.136,8.975",
    transform: "translate(-193.513 -89.44)",
    fill: "#ffa12e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_465",
    "data-name": "Grupo 465",
    transform: "translate(3.879 3.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_663",
    "data-name": "Caminho 663",
    d: "M199.075,102.7a15.229,15.229,0,0,1-6.718-7.55,4.851,4.851,0,0,0-.957-1.685,1.265,1.265,0,0,0-1.726-.073,2.926,2.926,0,0,0-.478,2.8c.988,4.191,4.014,8.674,7.53,9.953",
    transform: "translate(-189.06 -93.085)",
    fill: "#ffa12e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_467",
    "data-name": "Grupo 467",
    transform: "translate(5.128 3.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_466",
    "data-name": "Grupo 466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_664",
    "data-name": "Caminho 664",
    d: "M197.27,101.048a21.432,21.432,0,0,1-3.827-5.065c-.749-1.238-1.487-2.621-2.881-3.193-.3-.125-.426.364-.135.478,1.6.655,2.454,2.787,3.307,4.181a17.647,17.647,0,0,0,3.182,3.952c.239.208.593-.135.354-.354Z",
    transform: "translate(-190.261 -92.771)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_469",
    "data-name": "Grupo 469",
    transform: "translate(8.211 1.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_468",
    "data-name": "Grupo 468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_665",
    "data-name": "Caminho 665",
    d: "M200.261,100.1a33.062,33.062,0,0,1-4.586-5.959,32.144,32.144,0,0,0-1.966-3.38c-.187-.25-.624,0-.437.25a34.857,34.857,0,0,1,2.08,3.578,34.5,34.5,0,0,0,4.555,5.866c.218.239.572-.114.354-.354Z",
    transform: "translate(-193.226 -90.661)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_470",
    "data-name": "Grupo 470",
    transform: "translate(21.879 5.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666",
    "data-name": "Caminho 666",
    d: "M212.465,108.6c.551-4.3-1.456-9.464-2.933-12.282a3.627,3.627,0,0,0-.936-1.258,1.31,1.31,0,0,0-1.477-.125,1.834,1.834,0,0,0-.624,1.248A9.481,9.481,0,0,0,208.5,103.7",
    transform: "translate(-206.368 -94.761)",
    fill: "#ffa12e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_472",
    "data-name": "Grupo 472",
    transform: "translate(17.166 15.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_471",
    "data-name": "Grupo 471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_667",
    "data-name": "Caminho 667",
    d: "M207,108.348a4.308,4.308,0,0,0-4.982-4.306c-.312.052-.187.541.135.478a3.8,3.8,0,0,1,4.347,3.817.25.25,0,0,0,.5.01Z",
    transform: "translate(-201.837 -103.98)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_473",
    "data-name": "Grupo 473",
    transform: "translate(12.038 1.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_668",
    "data-name": "Caminho 668",
    d: "M209.536,100.661a14.042,14.042,0,0,1-6.334-3.723,35.587,35.587,0,0,1-3.214-4.878,3.882,3.882,0,0,0-1.123-1.331,1.354,1.354,0,0,0-1.633.062,1.879,1.879,0,0,0-.177,1.841,12.69,12.69,0,0,0,7.5,8.185",
    transform: "translate(-196.906 -90.487)",
    fill: "#ffa12e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_475",
    "data-name": "Grupo 475",
    transform: "translate(12.013 1.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_474",
    "data-name": "Grupo 474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_669",
    "data-name": "Caminho 669",
    d: "M202.33,98.754c-2.2-2.07-3.567-4.9-4.982-7.519-.156-.281-.582-.031-.437.25,1.435,2.662,2.829,5.522,5.065,7.613a.246.246,0,0,0,.354-.343Z",
    transform: "translate(-196.881 -91.112)",
    fill: "#220d59"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_477",
    "data-name": "Grupo 477",
    transform: "translate(126.342 172.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_670",
    "data-name": "Caminho 670",
    d: "M320.91,202.028q33.478,33.478,33.478,80.756T320.91,363.54q-33.478,33.478-80.756,33.478T159.4,363.54q-33.478-33.478-33.478-80.756T159.4,202.028q33.478-33.478,80.756-33.478Q287.438,168.566,320.91,202.028Zm-80.756-4.316q-35.287,0-60.185,24.9t-24.9,60.185q0,35.287,24.97,60.258t60.112,24.96q35.287,0,60.185-24.96t24.9-60.258q0-35.287-24.9-60.185T240.154,197.712Z",
    transform: "translate(-125.92 -168.55)",
    fill: "#6de1fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_671",
    "data-name": "Caminho 671",
    d: "M403.241,323.117v71.407H374.37V171.37H437.7q26.91,3.635,45.469,22.173,22.183,22.324,22.173,53.56,0,31.528-22.173,53.768T429.6,323.117H403.241Zm0-122.731v93.725H429.6A46.907,46.907,0,0,0,476.332,247.1,46.782,46.782,0,0,0,429.6,200.386H403.241Z",
    transform: "translate(-115.981 -168.437)",
    fill: "#6de1fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_672",
    "data-name": "Caminho 672",
    d: "M576.991,280.116q-23.712-7.956-38.428-22.662t-14.716-36.473q0-21.341,15.267-36.681a52.275,52.275,0,0,1,73.851-.135q8.642,8.362,14.508,26.635l-26.219,10.317q-4.742-12.823-8.653-16.734a23.658,23.658,0,0,0-33.051.062,22.369,22.369,0,0,0-6.833,16.526,22.6,22.6,0,0,0,6.833,16.6q7.675,7.535,21.2,13.811,26.224,8.518,44.491,26.78,20.5,20.218,20.5,49.1T625.3,376.566Q604.863,397,576.138,397q-28.876,0-49.234-20.5-16.318-16.318-20.644-45.053L534.3,321.269q2.652,24.695,12.969,35.007A40.877,40.877,0,0,0,605.008,298.4,84.5,84.5,0,0,0,576.991,280.116Z",
    transform: "translate(-110.705 -168.534)",
    fill: "#6de1fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_513",
    "data-name": "Grupo 513",
    transform: "translate(455.438 121.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_673",
    "data-name": "Caminho 673",
    d: "M481.2,168.848c-.759,18.564-9.859,31.481,6.261,39.739,8.372,4.285,22.922-7.27,29.38-22.246,2.933-6.8,25.012-6.25,9.61,21.424-13.614,24.45-46.187,27-54.465,23.982C461.419,227.91,482.147,145.636,481.2,168.848Z",
    transform: "translate(-441.292 -117.899)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_674",
    "data-name": "Caminho 674",
    d: "M469.308,226.843c1.976-2.132,6.937-2.174,11.086-.094,3.026,1.529,4.774,3.765,4.722,5.7a41.746,41.746,0,0,1-11.232-1.789,21.688,21.688,0,0,1-5.3-2.465A2.84,2.84,0,0,1,469.308,226.843Z",
    transform: "translate(-441.308 -115.479)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_486",
    "data-name": "Grupo 486",
    transform: "translate(89.707 36.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_675",
    "data-name": "Caminho 675",
    d: "M529.983,171.4s-3.307-7.2,6.448-9.038c0,0-1.269-2.662-5.346-3.307-3.276-.52-3.546-4.139.718-3.962s9.662,3.723,10.608,8.757-.978,11.263-4.056,17.378S529.983,171.4,529.983,171.4Z",
    transform: "translate(-528.614 -155.084)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_479",
    "data-name": "Grupo 479",
    transform: "translate(2.237 9.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_478",
    "data-name": "Grupo 478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_676",
    "data-name": "Caminho 676",
    d: "M531.457,165a4.9,4.9,0,0,1,2.943,2.642,1.5,1.5,0,0,1-1.092,2.09,2.839,2.839,0,0,1-2.184-.718c-.26-.187-.51.239-.25.437,1.227.894,3.692,1.394,4.139-.645s-1.841-3.619-3.422-4.274c-.3-.146-.426.343-.135.468Z",
    transform: "translate(-530.764 -164.504)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_481",
    "data-name": "Grupo 481",
    transform: "translate(3.769 6.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_480",
    "data-name": "Grupo 480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_677",
    "data-name": "Caminho 677",
    d: "M532.7,165.533a6.08,6.08,0,0,1,6.843-3.338c.312.062.447-.416.135-.478a6.588,6.588,0,0,0-7.4,3.567c-.156.291.281.541.426.25Z",
    transform: "translate(-532.238 -161.564)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_483",
    "data-name": "Grupo 483",
    transform: "translate(5.642 9.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_482",
    "data-name": "Grupo 482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_678",
    "data-name": "Caminho 678",
    d: "M534.466,167.092a6.747,6.747,0,0,1,5.668-2.111c.322.031.322-.468,0-.5a7.232,7.232,0,0,0-6.022,2.257c-.229.229.125.593.354.354Z",
    transform: "translate(-534.039 -164.446)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_485",
    "data-name": "Grupo 485",
    transform: "translate(5.119 14.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_484",
    "data-name": "Grupo 484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_679",
    "data-name": "Caminho 679",
    d: "M533.717,169.589a1.309,1.309,0,0,0,1.238,2.007,2.161,2.161,0,0,0,1.3-.894,4.832,4.832,0,0,1,2.59-1.633c.312-.073.177-.562-.135-.478a5.148,5.148,0,0,0-1.924.884,6.386,6.386,0,0,0-.811.78,2.948,2.948,0,0,1-.53.551c-.478.312-2.07.458-1.31-.957.166-.291-.26-.541-.416-.26Z",
    transform: "translate(-533.536 -168.581)",
    fill: "#220d59"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_680",
    "data-name": "Caminho 680",
    d: "M524.5,130.339s9.173,34.632-12.938,21.892l.281,21.632L495.36,156.672l6.729-20.883S500.477,115.5,524.5,130.339Z",
    transform: "translate(-440.237 -119.492)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_681",
    "data-name": "Caminho 681",
    d: "M520.562,140.844c-.114.541-.021,1.019.218,1.071s.53-.343.645-.874.021-1.019-.218-1.071S520.687,140.313,520.562,140.844Z",
    transform: "translate(-439.231 -118.89)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_488",
    "data-name": "Grupo 488",
    transform: "translate(81.247 28.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_487",
    "data-name": "Grupo 487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_682",
    "data-name": "Caminho 682",
    d: "M520.74,147.6a1.643,1.643,0,0,1,1.685,1c.146.322.6.042.468-.27a2.157,2.157,0,0,0-2.153-1.269c-.343.031-.354.572,0,.541Z",
    transform: "translate(-520.479 -147.053)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_683",
    "data-name": "Caminho 683",
    d: "M521.092,137.364c.177.322.79.333,1.362.021s.894-.832.707-1.165-.79-.333-1.362-.021S520.915,137.041,521.092,137.364Z",
    transform: "translate(-439.209 -119.049)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_684",
    "data-name": "Caminho 684",
    d: "M524.53,136.46l.52.988,3.7,7.384-3.8.853Z",
    transform: "translate(-439.07 -119.03)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_685",
    "data-name": "Caminho 685",
    d: "M524.53,136.46l.52.988,3.7,7.384-3.8.853Z",
    transform: "translate(-439.07 -119.03)",
    fill: "#ed743a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_686",
    "data-name": "Caminho 686",
    d: "M514.062,152.765l-3.182-1.685.2,7.374Z",
    transform: "translate(-439.616 -118.445)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_489",
    "data-name": "Grupo 489",
    transform: "translate(55.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_687",
    "data-name": "Caminho 687",
    d: "M508.208,140.344a5.185,5.185,0,0,0,7.353-3.12,8.761,8.761,0,0,1,.614-2.506,3.65,3.65,0,0,1,3.224-1.508c1.248-.01,2.475.281,3.723.208a5.266,5.266,0,0,0,4.919-4.15c.333-2.3-1.778-4.763-4.077-4.4-.655.1-1.279.406-1.934.52-3.016.51-5.065-2.87-7.623-4.555a7.939,7.939,0,0,0-11.045,3.058c-.437.9-.686,1.9-1.206,2.766-1.05,1.737-3,2.683-4.545,4s-2.746,3.6-1.674,5.325c.437.707,1.206,1.206,1.477,1.986.468,1.331-.645,2.652-.936,4.035a4.233,4.233,0,0,0,2.985,4.649,6.171,6.171,0,0,0,5.647-1.383,11.7,11.7,0,0,0,3.234-5.054",
    transform: "translate(-495.526 -119.7)",
    fill: "#220d59"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_688",
    "data-name": "Caminho 688",
    d: "M504.2,138.584a4.142,4.142,0,1,1,2.777,5.158A4.144,4.144,0,0,1,504.2,138.584Z",
    transform: "translate(-439.89 -119.063)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_491",
    "data-name": "Grupo 491",
    transform: "translate(67.605 18.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_490",
    "data-name": "Grupo 490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_689",
    "data-name": "Caminho 689",
    d: "M507.558,138.06a2.171,2.171,0,0,1,1.841,2.506c-.062.343.458.489.52.146a2.712,2.712,0,0,0-2.215-3.172c-.343-.052-.489.468-.146.52Z",
    transform: "translate(-507.362 -137.537)",
    fill: "#220d59"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_690",
    "data-name": "Caminho 690",
    d: "M516.224,204.362l-11.825,31.7s-41.153,10.41-57.356-12.771c0,0-3.91-70.575,46.478-70.96C529.5,152.049,529.224,170.374,516.224,204.362Z",
    transform: "translate(-442.173 -118.395)",
    fill: "#548aef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_691",
    "data-name": "Caminho 691",
    d: "M524.857,414.3l-11.71-.707-.676,18.044,5.325-.135-.291-2.038,6.978,2.33,28.215.291a38.909,38.909,0,0,0-15.07-7.644,19.713,19.713,0,0,1-12.771-10.14Z",
    transform: "translate(-439.552 -107.944)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_692",
    "data-name": "Caminho 692",
    d: "M461.688,413.278l-9.61-.728-3.068,18.47,5.45-.135.894-2.08,8.341,2.382,26.51.3a39.726,39.726,0,0,0-15.548-7.852,19.86,19.86,0,0,1-12.906-10.244Z",
    transform: "translate(-442.091 -107.985)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_693",
    "data-name": "Caminho 693",
    d: "M505.041,231.976S472,234.17,447.186,219.87c0,0-9.776,23.317-1.508,55.661s18.98,89.2,1.685,147.868c0,0,13.1,6.9,24.814,2.756,0,0,26.156-62.619,24.648-103.241,0,0,21.06,36.858,12.033,101.546,0,0,13.541,5.262,25.574.749,0,0,9.027-30.087,9.776-62.431s-6.771-68.453-18.054-91.77S507.808,238.964,505.041,231.976Z",
    transform: "translate(-442.357 -115.693)",
    fill: "#9b5eed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_492",
    "data-name": "Grupo 492",
    transform: "translate(18.925 142.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_694",
    "data-name": "Caminho 694",
    d: "M495.993,322.374c-.6-12.262-16-24.815-22.578-32.719a51.147,51.147,0,0,1-12.3-32.9s-4.139,17.306,10.151,46.634c11.648,23.9,20.311,55.661,13.541,81.994C484.813,385.388,497.408,351.13,495.993,322.374Z",
    transform: "translate(-460.555 -256.76)",
    fill: "#220d59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_494",
    "data-name": "Grupo 494",
    transform: "translate(27.001 125.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_493",
    "data-name": "Grupo 493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_695",
    "data-name": "Caminho 695",
    d: "M494.913,243.322a55.569,55.569,0,0,1-26.177-2.631c-.416-.146-.593.52-.187.666a56.413,56.413,0,0,0,26.541,2.631c.437-.062.25-.718-.177-.666Z",
    transform: "translate(-468.32 -240.67)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_496",
    "data-name": "Grupo 496",
    transform: "translate(26.747 131.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_495",
    "data-name": "Grupo 495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_696",
    "data-name": "Caminho 696",
    d: "M494.195,248.216A40.53,40.53,0,0,1,468.6,246c-.406-.166-.749.416-.343.593a41.3,41.3,0,0,0,26.125,2.288.346.346,0,0,0-.187-.666Z",
    transform: "translate(-468.075 -245.972)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_498",
    "data-name": "Grupo 498",
    transform: "translate(2.267 118.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_497",
    "data-name": "Grupo 497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_697",
    "data-name": "Caminho 697",
    d: "M458.372,238.249a22.962,22.962,0,0,1-13.343-4.576c-.354-.26-.7.333-.343.593a23.484,23.484,0,0,0,13.686,4.67.343.343,0,0,0,0-.686Z",
    transform: "translate(-444.537 -233.608)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_500",
    "data-name": "Grupo 500",
    transform: "translate(1.109 123.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_499",
    "data-name": "Grupo 499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_698",
    "data-name": "Caminho 698",
    d: "M453.934,242.858a17.664,17.664,0,0,1-9.911-4.025c-.333-.281-.822.208-.489.489a18.41,18.41,0,0,0,10.4,4.222c.437.031.437-.655,0-.686Z",
    transform: "translate(-443.423 -238.749)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_502",
    "data-name": "Grupo 502",
    transform: "translate(59.408 116.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_501",
    "data-name": "Grupo 501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_699",
    "data-name": "Caminho 699",
    d: "M499.48,232.143a54.029,54.029,0,0,0,3.39,18.543,126.776,126.776,0,0,0,7.914,16.526c3.172,5.855,6.354,11.71,8.965,17.846a121.952,121.952,0,0,1,5.138,14.914c6.6,23.525,8.622,48.433,7.467,72.78a255.281,255.281,0,0,1-8.06,52.645.346.346,0,0,0,.666.187,256.017,256.017,0,0,0,7.27-88.66,217.658,217.658,0,0,0-5.554-32.906c-1.092-4.316-2.34-8.6-3.817-12.8a134.588,134.588,0,0,0-8.455-18.73c-3.37-6.334-7.03-12.553-9.786-19.2a55.237,55.237,0,0,1-4.451-21.154.344.344,0,0,0-.686.01Z",
    transform: "translate(-499.48 -231.814)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_504",
    "data-name": "Grupo 504",
    transform: "translate(62.901 126.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_503",
    "data-name": "Grupo 503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_700",
    "data-name": "Caminho 700",
    d: "M506.875,241.243c.146,3.3-.822,7.176-3.869,8.944a.343.343,0,0,0,.343.593c3.255-1.882,4.368-5.99,4.2-9.537-.01-.437-.7-.437-.676,0Z",
    transform: "translate(-502.838 -240.915)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_506",
    "data-name": "Grupo 506",
    transform: "translate(64.775 131.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_505",
    "data-name": "Grupo 505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_701",
    "data-name": "Caminho 701",
    d: "M509.372,246.21c-.53,3.411-1.622,6.552-4.576,8.59-.364.25-.021.842.343.593,3.11-2.153,4.326-5.377,4.888-9,.073-.437-.593-.624-.655-.187Z",
    transform: "translate(-504.641 -245.961)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_508",
    "data-name": "Grupo 508",
    transform: "translate(18.681 120.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_507",
    "data-name": "Grupo 507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_702",
    "data-name": "Caminho 702",
    d: "M461.818,236.05a77.182,77.182,0,0,0-1.5,13.655.344.344,0,0,0,.686,0,76.052,76.052,0,0,1,1.477-13.468c.083-.437-.582-.624-.666-.187Z",
    transform: "translate(-460.32 -235.801)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_510",
    "data-name": "Grupo 510",
    transform: "translate(21.185 111.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_509",
    "data-name": "Grupo 509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_703",
    "data-name": "Caminho 703",
    d: "M464.259,227.089q-.842,2.465-1.518,4.971a.346.346,0,0,0,.666.187q.671-2.512,1.518-4.971c.146-.426-.52-.6-.666-.187Z",
    transform: "translate(-462.727 -226.852)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_704",
    "data-name": "Caminho 704",
    d: "M509.16,156.23a41.567,41.567,0,0,1,30.514,22.984c8.247,16.65,6.458,32.355,24.565,31.866,9.4-.26,16.619-17.389,15.1-33.613-.686-7.374,22.474-12.563,18.158,18.8-4.982,36.234-27.009,41.226-35.724,42.557-11.107,1.7-35.662-7.041-42.38-41.746C511.854,158.112,509.16,156.23,509.16,156.23Z",
    transform: "translate(-439.685 -118.239)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_705",
    "data-name": "Caminho 705",
    d: "M550.739,205.015c-3.266-6.032-6.448-16.848-10.868-25.782-10.306-20.821-29.11-23.67-29.11-23.67s-18.626-3.6,7.093,44.543c3.983,7.457,5.97,12.106,9.194,17.649a55.372,55.372,0,0,0,12.771-4.763A51.076,51.076,0,0,0,550.739,205.015Z",
    transform: "translate(-439.881 -118.268)",
    fill: "#548aef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_706",
    "data-name": "Caminho 706",
    d: "M575.31,193.848c1.841-9.11,1.134-16.224,1.31-20.561-.083-7.415,3.484-6.022,4.233-3.6a1.92,1.92,0,0,1-.052.728l.073.01c.094-2.174.978-3.338,2.288-3.3.936.031,1.622.634,2.122,1.966.447-1.092,1.175-1.8,2.018-1.768.874.031,1.664.822,2.174,2.018.406-.957,1.05-1.591,1.8-1.539,3.921.3,5.023,19.49,3.3,29.058",
    transform: "translate(-437.038 -117.803)",
    fill: "#ffa12e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_512",
    "data-name": "Grupo 512",
    transform: "translate(83.806 80.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_511",
    "data-name": "Grupo 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_707",
    "data-name": "Caminho 707",
    d: "M546.819,197.513a58.565,58.565,0,0,1-23.65,12,.324.324,0,0,0,.177.624,59.438,59.438,0,0,0,23.941-12.168c.312-.27-.156-.728-.468-.458Z",
    transform: "translate(-522.939 -197.431)",
    fill: "#eeeff2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_708",
    "data-name": "Caminho 708",
    d: "M554.236,234.353c.894-2.766,5.377-4.9,10.015-4.753,3.39.1,5.918,1.4,6.687,3.172A41.88,41.88,0,0,1,560,235.882a21.555,21.555,0,0,1-5.855,0A2.86,2.86,0,0,1,554.236,234.353Z",
    transform: "translate(-437.888 -115.304)",
    fill: "#ed743a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_709",
    "data-name": "Caminho 709",
    d: "M516.67,196.021l-4.545-7.311L508.1,217.57Z",
    transform: "translate(-439.727 -116.94)",
    fill: "#220d59"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_710",
    "data-name": "Caminho 710",
    d: "M639.284,144.992a4.375,4.375,0,1,0-3.64,5A4.381,4.381,0,0,0,639.284,144.992Z",
    transform: "translate(20.611 3.004)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_711",
    "data-name": "Caminho 711",
    d: "M432.381,125.477a19.518,19.518,0,1,0,9.724,25.834A19.515,19.515,0,0,0,432.381,125.477Z",
    transform: "translate(11.578 2.301)",
    fill: "none",
    stroke: "#d8d8d8",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_712",
    "data-name": "Caminho 712",
    d: "M389.99,100.065a7.354,7.354,0,1,0,3.661,9.734A7.364,7.364,0,0,0,389.99,100.065Z",
    transform: "translate(10.57 1.328)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_713",
    "data-name": "Caminho 713",
    d: "M626.079,213.194c-3.11-1.4-6.625-.343-7.852,2.382s.281,6.063,3.39,7.478,6.625.343,7.852-2.382S629.178,214.608,626.079,213.194Z",
    transform: "translate(20.099 5.855)",
    fill: "none",
    stroke: "#220d59",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_714",
    "data-name": "Caminho 714",
    d: "M593.115,122.162a9.071,9.071,0,1,0,8.081,9.963A9.072,9.072,0,0,0,593.115,122.162Z",
    transform: "translate(18.711 2.236)",
    fill: "none",
    stroke: "#6de1fe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_715",
    "data-name": "Caminho 715",
    d: "M424.785,357.792a9.071,9.071,0,1,0,8.081,9.963A9.072,9.072,0,0,0,424.785,357.792Z",
    transform: "translate(11.977 11.662)",
    fill: "none",
    stroke: "#220d59",
    strokeWidth: 1.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_716",
    "data-name": "Caminho 716",
    d: "M174.145,192.711a18.459,18.459,0,1,0-10.806,23.764A18.458,18.458,0,0,0,174.145,192.711Z",
    transform: "translate(0.921 4.581)",
    fill: "#548aef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_717",
    "data-name": "Caminho 717",
    d: "M584.747,366.453a6.831,6.831,0,1,0,9.506-1.726A6.831,6.831,0,0,0,584.747,366.453Z",
    transform: "translate(18.728 11.893)",
    fill: "#220d59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_718",
    "data-name": "Caminho 718",
    d: "M126.293,243.605a5.414,5.414,0,1,0-3.172,6.968A5.424,5.424,0,0,0,126.293,243.605Z",
    transform: "translate(0.018 6.956)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_719",
    "data-name": "Caminho 719",
    d: "M357.861,66.21H310.894A14.414,14.414,0,0,0,296.48,80.624v.884A14.408,14.408,0,0,0,304.894,94.6l-1.685,9.714,12.917-8.393h41.746a14.414,14.414,0,0,0,14.414-14.414v-.884A14.43,14.43,0,0,0,357.861,66.21Z",
    transform: "translate(7.245 0)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "???",
    transform: "translate(324.647 86.022)",
    fill: "#548aef",
    fontSize: 17,
    fontFamily: "Caviar Dreams",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "???")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOps);
export default __webpack_public_path__ + "static/media/ops.eb1f5f055fd1d05391a659858e93b912.svg";
export { ForwardRef as ReactComponent };